import { useNavigate } from 'react-router';

import './not-found-page.css';
import { HOME_URL } from '../../config';
import { PageFooterContent, PageHeaderButtons } from '../menu';

import {  
    PageFooter, 
    PageHeader, 
    PageLayout, 
    PageSection, 
    PageMenu, 
    Button,
    Header,
    Icon,
} from '../../components/components';

export function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <PageLayout
            header={<PageHeader name="Puzzel wallboards" menu={<PageMenu><PageHeaderButtons /></PageMenu>} />}
            footer={<PageFooter><PageFooterContent /></PageFooter>}>
            <PageSection centered="true">
                <Icon name="manypixels_404" class="not-found-icon" />

                <Header>
                    Page not found
                </Header>

                <Button 
                    variant="label"
                    icon="ic_keyboard_backward"
                    clicked={() => navigate(HOME_URL)}>
                    Home
                </Button>
            </PageSection>
        </PageLayout>
    );
}